import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import SignIn from 'components/auth/signIn';
import SignUp from 'components/auth/signUp';
import Dashboard from 'components/dashboard';
import AddStrings from 'components/dashboard/developerDashboard/addStrings';
import ManageTranslations from 'components/dashboard/developerDashboard/manageTranslations';
import ManageLanguages from 'components/dashboard/developerDashboard/manageLanguages';
import ManageUsers from 'components/dashboard/developerDashboard/manageUsers';
import requireAuth from './requireAuth';

export default () => (
  <Switch>
    <Route path="/" exact component={requireAuth(Dashboard)} />
    <Route
      path="/add-strings"
      exact
      component={requireAuth(AddStrings, { adminOnly: true })}
    />
    <Route
      path="/manage-translations"
      exact
      component={requireAuth(ManageTranslations, { adminOnly: true })}
    />
    <Route
      path="/manage-users"
      exact
      component={requireAuth(ManageUsers, { adminOnly: true })}
    />
    <Route
      path="/manage-languages"
      exact
      component={requireAuth(ManageLanguages, { adminOnly: true })}
    />
    <Route
      path="/sign-in"
      exact
      component={requireAuth(SignIn, { noAuth: true })}
    />
    <Route
      path="/sign-up"
      exact
      component={requireAuth(SignUp, { noAuth: true })}
    />

    <Redirect from="*" to="/" />
  </Switch>
);



// WEBPACK FOOTER //
// ./src/router/routes.js